export default function ProductCarriers() {
  return {
    productCategory: 'Term',
    productCarrierData: [
      {
        carrierName: "Americo",
        displayOrder: 1,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/americo.png",
      },
      {
        carrierName: "Corebridge",
        displayOrder: 2,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/corebridge.png",
      },
      {
        carrierName: "Equitable",
        displayOrder: 3,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/equitable.png",
      },
      {
        carrierName: "John Hancock",
        displayOrder: 4,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/john-hancock.png",
      },
      {
        carrierName: "Legal & General",
        displayOrder: 5,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/lga.png",
      },
      {
        carrierName: "Lincoln",
        displayOrder: 6,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/lincoln.png",
      },
      {
        carrierName: "Mass Mutual",
        displayOrder: 7,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/mass-mutual.png",
      },
      {
        carrierName: "Mutual of Omaha",
        displayOrder: 8,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/mutual-of-omaha.png",
      },
      {
        carrierName: "Nationwide",
        displayOrder: 9,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/nationwide.png",
      },
      {
        carrierName: "Pacific Life",
        displayOrder: 10,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/pacific-life.png",
      },
      {
        carrierName: "Protective",
        displayOrder: 11,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/protective.png",
      },
      {
        carrierName: "Prudential",
        displayOrder: 12,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/prudential.png",
      },
      {
        carrierName: "SBLI",
        displayOrder: 13,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/sbli.png",
      },
      {
        carrierName: "Securian",
        displayOrder: 14,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/securian.png",
      },
      {
        carrierName: "Symetra",
        displayOrder: 15,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/symetra.png",
      },
      {
        carrierName: "Transamerica",
        displayOrder: 16,
        logoLink: "https://nbapplicationdata.blob.core.windows.net/public/Consumer/logos/Carriers/transamerica.png",
      },
    ],
  };
}



// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/TermInsurance/ProductCarriers.js